var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Video",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8021",
    "data-name": "Rectangle 8021",
    width: 16,
    height: 16,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "live_tv_21dp_FFFFFF_FILL0_wght300_GRAD0_opsz20",
    d: "M123.091-787.44l3.327-2.137a.586.586,0,0,0,.315-.527.611.611,0,0,0-.315-.538l-3.327-2.137a.588.588,0,0,0-.65-.007.62.62,0,0,0-.331.57V-788a.621.621,0,0,0,.331.57A.588.588,0,0,0,123.091-787.44Zm-5.677,3.221a1.364,1.364,0,0,1-1-.41,1.366,1.366,0,0,1-.41-1v-8.959a1.354,1.354,0,0,1,.41-1,1.37,1.37,0,0,1,1-.407h13.173a1.364,1.364,0,0,1,1,.41,1.366,1.366,0,0,1,.41,1v8.959a1.355,1.355,0,0,1-.41,1,1.37,1.37,0,0,1-1,.407h-3.861v1.4a.685.685,0,0,1-.2.5.683.683,0,0,1-.5.2h-4.032a.7.7,0,0,1-.507-.2.679.679,0,0,1-.205-.5v-1.4Zm0-1.143h13.173a.258.258,0,0,0,.186-.085.258.258,0,0,0,.085-.186v-8.953a.258.258,0,0,0-.085-.186.258.258,0,0,0-.186-.085H117.413a.258.258,0,0,0-.186.085.258.258,0,0,0-.085.186v8.953a.258.258,0,0,0,.085.186A.258.258,0,0,0,117.413-785.363Zm-.271,0v0Z",
    transform: "translate(-116 797)",
    fill: "#228285"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.0a859873bcbd880469d9860e04202e8c.svg";
export { ForwardRef as ReactComponent };